/**
 * MemoryStorage Implementation
 *
 * In-memory token storage implementation.
 * Primarily used for testing and server-side rendering environments where browser APIs are unavailable.
 */
/**
 * In-memory token storage implementation.
 * Tokens are stored in memory and will be lost when the instance is destroyed.
 *
 * @remarks
 * This implementation is useful for:
 * - Unit testing (no browser dependencies)
 * - Server-side rendering (SSR) environments
 * - Environments where browser storage is not available
 *
 * @example
 * ```typescript
 * const storage = new MemoryStorage();
 * storage.setTokens('access_token', 'refresh_token');
 * console.log(storage.getAccessToken()); // 'access_token'
 * ```
 */
export class MemoryStorage {
    accessToken = null;
    refreshToken = null;
    /**
     * Retrieves the stored access token from memory.
     *
     * @returns The access token string, or null if not set
     */
    getAccessToken() {
        return this.accessToken;
    }
    /**
     * Retrieves the stored refresh token from memory.
     *
     * @returns The refresh token string, or null if not set
     */
    getRefreshToken() {
        return this.refreshToken;
    }
    /**
     * Stores both access and refresh tokens in memory.
     *
     * @param accessToken - The access token to store
     * @param refreshToken - The refresh token to store
     */
    setTokens(accessToken, refreshToken) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }
    /**
     * Clears all stored tokens from memory.
     */
    clearTokens() {
        this.accessToken = null;
        this.refreshToken = null;
    }
}
//# sourceMappingURL=MemoryStorage.js.map